import React, { useState, useEffect } from "react";
import "../scss/news.scss";
import banner from "../assets/bg-news.jpg";
import Banner from "../components/Banner";
import Loading from "../components/Loading";

import {getNews} from "../utils/API";

const NewsContainer = ({ title, details, img }) => {
  return (
    <div className="news-wrapper">
      <div className="news-left">
        <h3>{title}</h3>
        <p>{details}</p>
      </div>
      <img src={`${process.env.REACT_APP_API_URI}/${img}`} alt={title} />
    </div>
  );
};

const News = () => {
  const [loading, setLoading] = useState(true);
  const [news, setNews] = useState([]);

  useEffect(() => {

    const fetchNews = async () => {
      try {
        const res = await getNews();
        setNews(res.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }

    fetchNews();
    document.title = "Actualités de Cartésia";
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Banner img={banner} />
      {loading ? (
        <Loading />
      ) : (
        <div className="news">
          {news.map((item) => (
            <NewsContainer
              key={item.title}
              title={item.title}
              details={item.details}
              img={item.src}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default News;
